// extracted by mini-css-extract-plugin
export default {"component":"fCLW2","top":"pkiNC","bottom":"osGHR","left":"Wio6h","right":"gmVZr"};